import { FormattedMessage } from "react-intl";
import { LabelLangString } from "component/LabelLang/label-lang.js";

export default function NationalSelectField({
  register,
  name,
  labelId,
  dir,
  currentLocale,
  options = [],
  optionValueKey = "id",
  optionLabelKey = "name",
  optionTranslationsKey = "Translation",
  variant = "dropdown",
  required = true,
  error,
}) {
  const select = (
    <select
      className={`${dir === "rtl" ? "r-dir" : "l-dir"}`}
      required={required}
      {...register(name)}
    >
      {options.map((option, i) => (
        <option
          key={i}
          value={option[optionValueKey]}
          title={LabelLangString({
            id: "name",
            currentLocale,
            defaultValue: option[optionLabelKey],
            translations: option[optionTranslationsKey],
          })}
        >
          {LabelLangString({
            id: "name",
            currentLocale,
            defaultValue: option[optionLabelKey],
            translations: option[optionTranslationsKey],
          })}
        </option>
      ))}
    </select>
  );

  return (
    <div className="form-label row">
      <div className="col-lg-4">
        <label>
          <FormattedMessage id={labelId} />:
        </label>
      </div>
      <div className="col-lg-8">
        {variant === "container" ? (
          <div className="form-label-container">
            {select}
            <span>*</span>
          </div>
        ) : (
          <div className="dropdown">
            {select}
            <span>*</span>
          </div>
        )}
        {error?.message && (
          <span className="alert alert-danger py-1">{error.message}</span>
        )}
      </div>
    </div>
  );
}
